"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Justeat = function Justeat(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M21.679 14.292l-.884 5.14c-.104.652-.151.673-.864.673h-.072c-.855 0-.869 0-.715-.948l.839-4.866h-1.506c-.582 0-.597 0-.46-.78.138-.779.138-.779.796-.779h4.628v.001c.596 0 .597 0 .462.78-.132.755-.136.779-.726.779h-1.498zM9.607 20.103H6.38c-1.195 0-1.205 0-.994-1.269l.848-4.925c.2-1.177.178-1.177 1.339-1.177h3.304c.595 0 .595.007.463.779-.133.773-.134.78-.785.78l-.002.001H7.846l-.229 1.345h2.065c.857 0 .857 0 .736.749-.106.712-.109.735-.679.735H7.372l-.229 1.422h2.786c.611 0 .611 0 .474.796-.134.74-.123.763-.735.764h-.061zm3.745-1.715l-.444.979c-.327.712-.322.735-1.045.735h-.072c-1.024 0-1.086-.06-.688-.886l2.767-5.736c.367-.748.352-.748 1.576-.748h.118c1.181.001 1.186.029 1.35.917l.981 5.505c.168.871.087.946-.769.948h-.042c-.795 0-.826 0-.933-.735l-.137-.979h-2.662zm.673-1.483h-.001v.002l.001-.002zm1.772 0l-.322-2.327c-.031-.212-.031-.212-.169-.212-.121 0-.121 0-.211.2l-1.07 2.339h1.772zM3.954 3.937c.814 0 .814.015.649.935l-.757 4.38c-.27 1.536-.933 2.817-2.605 3.359-.105.029-.407.121-.571.121-.164 0-.285-.091-.465-.557-.121-.316-.181-.468-.181-.618 0-.134.091-.256.391-.346 1.175-.361 1.566-.949 1.716-1.822l.668-3.892H1.597c-.587 0-.604-.025-.468-.793.136-.767.136-.767.799-.767h2.026zm6.831 0c.856 0 .893 0 .729.946l-.606 3.521c-.335 2.126-1.337 3.012-3.325 3.012-1.775 0-3.013-1.245-2.663-3.258l.609-3.554c.107-.673.129-.666.95-.666.843 0 .869-.005.716.943l-.578 3.385c-.153.917.186 1.515 1.181 1.515.995 0 1.271-.603 1.44-1.627l.611-3.543c.115-.669.132-.674.936-.674h-.001.001zm3.723 5.817c.652-.037.995-.318.995-.638 0-.381-.474-.52-1.1-.704-1.239-.381-2.341-.816-2.341-2.131 0-1.546 1.272-2.386 2.877-2.386.673 0 1.446.039 1.946.084.449.043.532.202.416.875-.115.673-.271.742-.643.709a17.73 17.73 0 0 0-1.761-.074c-.826.01-1.061.291-1.061.58 0 .351.322.55 1.087.749 1.421.413 2.354.973 2.354 2.197 0 1.438-1.07 2.278-2.783 2.346-.818.03-1.637-.015-2.446-.136-.546-.08-.565-.09-.429-.873.124-.715.142-.765.643-.704.965.117 1.593.143 2.246.105v.001zm8.932-5.817h.001c.597 0 .597 0 .461.78-.136.78-.136.78-.785.78h-1.438l-.885 5.139c-.107.673-.153.673-.935.673-.855 0-.869 0-.716-.948l.841-4.864h-1.508c-.582 0-.597-.001-.46-.78.138-.78.138-.78.795-.78h4.629z"
  }));
};

Justeat.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Justeat.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Justeat;
exports.default = _default;